// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infoContainerWrapper_hVLfq {
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 0;
  justify-content: space-between;
  cursor: pointer;
}
.infoContainer_qMj2f {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0;
  padding: 0;
  div {
    color: #1f184b;
    font-size: 12px;
    font-weight: 500;
  }
  span {
    max-width: 360px;
    color: #1f184b;
    font-size: 12px;
    font-weight: 300;
  }
}

.contentContainer_JUQEJ {
  &.active_YIBR9 {
    display: block;
  }
  &.disabled__wTU3 {
    display: none;
  }
}

.contentContainerWrapper_Rj5yt {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* .variablesContainer  {
  display: flex;
} */

.variableItemContainer_lP4CE {
  border-bottom: 1px solid var(--e0-border);
  border-left: 1px solid var(--e0-border);
  border-right: 1px solid var(--e0-border);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 4px;
}

.variableItem_zv4Mm {
  display: flex;
  align-items: center;
  gap: 5px;
  min-height: 50px;
}

.infoVariableTop_i9WtL{
  display: flex;
  align-items: center;
  gap: 10px;
  p{
    margin: 0;
    font-size: 10px;
    border: 1px solid var(--e0-border);
    background-color: var(--white-color);
    padding: 2px 4px;
    border-radius: 50px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: bolder;
    color: var(--_18181b-color);
  }
}
.typeVariable_nKrT0{
  margin: 0;
  background-color: #656b74;
  border-radius: 8px;
  color: var(--white-color);
  padding: 3px 10px;
  font-size: 9px;
}

.required_pad0T{
  font-size: 14px;
  font-weight: bold;
  color: var(--_18181b-color);
}
.cardContainer_CTUYL {
  border: 1px solid var(--e0-border);
  border-bottom: none;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}

.labelInput_AU3d2 {
  color: var(--_1f184b-color);
  font-size: 13px;
  line-height: 1;
  border-bottom: 0px solid var(--e8-border);
  border-top: 0px solid var(--e8-border);
  margin-top: 0px;
  margin-bottom: 0px;
  margin-bottom: 6px;
}

.inputContainer_jEO9j {
  display: flex;
  gap: 8px;
  padding: 5px 16px;
  background: var(--f1-background);
  border-radius: 6px;
  align-items: center;
}

.inputSearchEnpoints_mHm47 {
  padding: 0px;
  margin: 0px;
  height: 20px;
  border: none;
  outline: none;
  background-color: transparent;
  color: var(--black-color);
  font-size: 14px;
}

.buttonInputSearchEndPoints_KA8Py {
  padding: 0px 10px;
  margin: 0px;
  height: 20px;
  /* width: 100%; */
  /* max-width: 160px; */
  border-radius: 8px;
  border: none;
  outline: none;
  background-color: var(--white-background);
  color: rgb(0, 0, 0);
  font-size: 12px;
  cursor: pointer;
  font-weight: 550;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  white-space: nowrap;
}

.methodPOST_egPdr {
  background-color: #2b00ff;
  color: var(--white-color);
  font-size: 12px;
  font-weight: 500;
  border-radius: 8px;
  padding: 3px 10px;
  cursor: pointer;
  border: none;
  margin-left: 10px;
}

.methodGET_cY67A {
  background-color: var(--_10a37f-background);
  color: var(--white-color);
  font-size: 12px;
  font-weight: 500;
  border-radius: 8px;
  padding: 3px 10px;
  cursor: pointer;
  border: none;
  margin-left: 10px;
}

.methodPUT_hw3AJ {
  background-color: #007ac0;
  color: var(--white-color);
  font-size: 12px;
  font-weight: 500;
  border-radius: 8px;
  padding: 3px 10px;
  cursor: pointer;
  border: none;
  margin-left: 10px;
}

.methodDELETE_q9NV0 {
  background-color: #ff0000;
  color: var(--white-color);
  font-size: 12px;
  font-weight: 500;
  border-radius: 8px;
  padding: 3px 10px;
  cursor: pointer;
  border: none;
  margin-left: 10px;
}

.methodPATCH_ks_Xz {
  background-color: #bd9100;
  color: var(--white-color);
  font-size: 12px;
  font-weight: 500;
  border-radius: 8px;
  padding: 3px 10px;
  cursor: pointer;
  border: none;
  margin-left: 10px;
}

.title_Yv_2c {
  font-size: 10px;
  border: 1px solid var(--e0-border);
  background-color: var(--white-color);
  padding: 2px 4px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.buttonShowMore_N8b2S {
  background-color: var(--white-background);
  color: var(--_10a37f-background);
  font-size: 12px;
  font-weight: 500;
  border-radius: 8px;
  padding: 0px 0px;
  cursor: pointer;
  border: none;
  margin-left: 0px;
}

.customSelector_JMk7L {
  position: relative;
  cursor: pointer;
}



.selectorOption_fkkob {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  transition: background-color 0.2s;
}

.selectorOption_fkkob:hover {
  background-color: var(--f5-background);
}

.customSelector_JMk7L {
  position: relative;
  cursor: pointer;
}

.optionsContainer_fehlA {
  position: absolute;
  top: 100%;
  left: 0;
  background: rgb(255, 255, 255);
  width: 100%;
  margin-top: 3px;
  z-index: 1;
  border-radius: 6px;
  box-shadow: 0px 4px 8px var(--_0000001a-shadow);
  text-decoration: none;

  div {
    padding: 2px 2px;
    color: #9c9d9f;
    list-style-type: none;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 4px;
    &:hover {
      background-color: var(--f5-background);
    }
  }
}

.type_pPCNh {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 0px 4px 18px;
  font-size: 12px;
  cursor: default;
  border-top: 1px solid var(--e0-border);
}

.deleteOption_lOPvy {
  position: absolute;
  left: -75%; 
  cursor: pointer;
  background-color: var(--white-background);
  padding: 2px 4px;
  border-radius: 6px 0px 0px 6px;
  width: 70%;
  border-left: 1px solid var(--e0-border);
  border-top: 1px solid var(--e0-border);
  border-bottom: 1px solid var(--e0-border);
}

.selectorOption_fkkob {
  position: relative;
}

.infoDescription_aDLlb {
  font-size: 12px;
  padding-left: 4px;
}


.variableContainer_wKffQ{
  margin: 10px 0;
  .searchVariable_bsCeL{
    border: none;
    outline: none;
    font-size: 14px;
    font-weight: 400;
    min-height: 21px !important;
    background-color: var(--f4-background);
    border-radius: 5px;
    box-sizing: border-box;
    width: 100%;
    padding: 8px;
  }
  .addVariableButton_qbOKw{
    width: 100%;

  }
}

.searchContainerIcon_k8qsK {
  background-color: var(--ececf1-background);
  padding: 4px;
  border-radius: 4px;
  height: 10px;
  width: 10px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  -ms-border-radius: 4px;
  -o-border-radius: 4px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/DataToSync/DataToSync.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN,UAAU;EACV;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;GAEG;;AAEH;EACE,yCAAyC;EACzC,uCAAuC;EACvC,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;IACE,SAAS;IACT,eAAe;IACf,kCAAkC;IAClC,oCAAoC;IACpC,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,2BAA2B;EAC7B;AACF;AACA;EACE,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,yCAAyC;EACzC,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,+CAA+C;EAC/C,qBAAqB;;EAErB;IACE,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,QAAQ;IACR;MACE,sCAAsC;IACxC;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,yCAAyC;EACzC,gBAAgB;EAChB,8BAA8B;EAC9B,UAAU;EACV,uCAAuC;EACvC,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;;AAGA;EACE,cAAc;EACd;IACE,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,sCAAsC;IACtC,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;;EAEb;AACF;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;AACjB","sourcesContent":[".infoContainerWrapper {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n  padding: 0;\n  justify-content: space-between;\n  cursor: pointer;\n}\n.infoContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0;\n  padding: 0;\n  div {\n    color: #1f184b;\n    font-size: 12px;\n    font-weight: 500;\n  }\n  span {\n    max-width: 360px;\n    color: #1f184b;\n    font-size: 12px;\n    font-weight: 300;\n  }\n}\n\n.contentContainer {\n  &.active {\n    display: block;\n  }\n  &.disabled {\n    display: none;\n  }\n}\n\n.contentContainerWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n/* .variablesContainer  {\n  display: flex;\n} */\n\n.variableItemContainer {\n  border-bottom: 1px solid var(--e0-border);\n  border-left: 1px solid var(--e0-border);\n  border-right: 1px solid var(--e0-border);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-right: 4px;\n}\n\n.variableItem {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  min-height: 50px;\n}\n\n.infoVariableTop{\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  p{\n    margin: 0;\n    font-size: 10px;\n    border: 1px solid var(--e0-border);\n    background-color: var(--white-color);\n    padding: 2px 4px;\n    border-radius: 50px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-weight: bolder;\n    color: var(--_18181b-color);\n  }\n}\n.typeVariable{\n  margin: 0;\n  background-color: #656b74;\n  border-radius: 8px;\n  color: var(--white-color);\n  padding: 3px 10px;\n  font-size: 9px;\n}\n\n.required{\n  font-size: 14px;\n  font-weight: bold;\n  color: var(--_18181b-color);\n}\n.cardContainer {\n  border: 1px solid var(--e0-border);\n  border-bottom: none;\n  border-top-right-radius: 8px;\n  border-top-left-radius: 8px;\n}\n\n.labelInput {\n  color: var(--_1f184b-color);\n  font-size: 13px;\n  line-height: 1;\n  border-bottom: 0px solid var(--e8-border);\n  border-top: 0px solid var(--e8-border);\n  margin-top: 0px;\n  margin-bottom: 0px;\n  margin-bottom: 6px;\n}\n\n.inputContainer {\n  display: flex;\n  gap: 8px;\n  padding: 5px 16px;\n  background: var(--f1-background);\n  border-radius: 6px;\n  align-items: center;\n}\n\n.inputSearchEnpoints {\n  padding: 0px;\n  margin: 0px;\n  height: 20px;\n  border: none;\n  outline: none;\n  background-color: transparent;\n  color: var(--black-color);\n  font-size: 14px;\n}\n\n.buttonInputSearchEndPoints {\n  padding: 0px 10px;\n  margin: 0px;\n  height: 20px;\n  /* width: 100%; */\n  /* max-width: 160px; */\n  border-radius: 8px;\n  border: none;\n  outline: none;\n  background-color: var(--white-background);\n  color: rgb(0, 0, 0);\n  font-size: 12px;\n  cursor: pointer;\n  font-weight: 550;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  white-space: nowrap;\n}\n\n.methodPOST {\n  background-color: #2b00ff;\n  color: var(--white-color);\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 8px;\n  padding: 3px 10px;\n  cursor: pointer;\n  border: none;\n  margin-left: 10px;\n}\n\n.methodGET {\n  background-color: var(--_10a37f-background);\n  color: var(--white-color);\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 8px;\n  padding: 3px 10px;\n  cursor: pointer;\n  border: none;\n  margin-left: 10px;\n}\n\n.methodPUT {\n  background-color: #007ac0;\n  color: var(--white-color);\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 8px;\n  padding: 3px 10px;\n  cursor: pointer;\n  border: none;\n  margin-left: 10px;\n}\n\n.methodDELETE {\n  background-color: #ff0000;\n  color: var(--white-color);\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 8px;\n  padding: 3px 10px;\n  cursor: pointer;\n  border: none;\n  margin-left: 10px;\n}\n\n.methodPATCH {\n  background-color: #bd9100;\n  color: var(--white-color);\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 8px;\n  padding: 3px 10px;\n  cursor: pointer;\n  border: none;\n  margin-left: 10px;\n}\n\n.title {\n  font-size: 10px;\n  border: 1px solid var(--e0-border);\n  background-color: var(--white-color);\n  padding: 2px 4px;\n  border-radius: 50px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.buttonShowMore {\n  background-color: var(--white-background);\n  color: var(--_10a37f-background);\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 8px;\n  padding: 0px 0px;\n  cursor: pointer;\n  border: none;\n  margin-left: 0px;\n}\n\n.customSelector {\n  position: relative;\n  cursor: pointer;\n}\n\n\n\n.selectorOption {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  transition: background-color 0.2s;\n}\n\n.selectorOption:hover {\n  background-color: var(--f5-background);\n}\n\n.customSelector {\n  position: relative;\n  cursor: pointer;\n}\n\n.optionsContainer {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  background: rgb(255, 255, 255);\n  width: 100%;\n  margin-top: 3px;\n  z-index: 1;\n  border-radius: 6px;\n  box-shadow: 0px 4px 8px var(--_0000001a-shadow);\n  text-decoration: none;\n\n  div {\n    padding: 2px 2px;\n    color: #9c9d9f;\n    list-style-type: none;\n    font-size: 13px;\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    gap: 4px;\n    &:hover {\n      background-color: var(--f5-background);\n    }\n  }\n}\n\n.type {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 0px 4px 18px;\n  font-size: 12px;\n  cursor: default;\n  border-top: 1px solid var(--e0-border);\n}\n\n.deleteOption {\n  position: absolute;\n  left: -75%; \n  cursor: pointer;\n  background-color: var(--white-background);\n  padding: 2px 4px;\n  border-radius: 6px 0px 0px 6px;\n  width: 70%;\n  border-left: 1px solid var(--e0-border);\n  border-top: 1px solid var(--e0-border);\n  border-bottom: 1px solid var(--e0-border);\n}\n\n.selectorOption {\n  position: relative;\n}\n\n.infoDescription {\n  font-size: 12px;\n  padding-left: 4px;\n}\n\n\n.variableContainer{\n  margin: 10px 0;\n  .searchVariable{\n    border: none;\n    outline: none;\n    font-size: 14px;\n    font-weight: 400;\n    min-height: 21px !important;\n    background-color: var(--f4-background);\n    border-radius: 5px;\n    box-sizing: border-box;\n    width: 100%;\n    padding: 8px;\n  }\n  .addVariableButton{\n    width: 100%;\n\n  }\n}\n\n.searchContainerIcon {\n  background-color: var(--ececf1-background);\n  padding: 4px;\n  border-radius: 4px;\n  height: 10px;\n  width: 10px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  -ms-border-radius: 4px;\n  -o-border-radius: 4px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoContainerWrapper": `infoContainerWrapper_hVLfq`,
	"infoContainer": `infoContainer_qMj2f`,
	"contentContainer": `contentContainer_JUQEJ`,
	"active": `active_YIBR9`,
	"disabled": `disabled__wTU3`,
	"contentContainerWrapper": `contentContainerWrapper_Rj5yt`,
	"variableItemContainer": `variableItemContainer_lP4CE`,
	"variableItem": `variableItem_zv4Mm`,
	"infoVariableTop": `infoVariableTop_i9WtL`,
	"typeVariable": `typeVariable_nKrT0`,
	"required": `required_pad0T`,
	"cardContainer": `cardContainer_CTUYL`,
	"labelInput": `labelInput_AU3d2`,
	"inputContainer": `inputContainer_jEO9j`,
	"inputSearchEnpoints": `inputSearchEnpoints_mHm47`,
	"buttonInputSearchEndPoints": `buttonInputSearchEndPoints_KA8Py`,
	"methodPOST": `methodPOST_egPdr`,
	"methodGET": `methodGET_cY67A`,
	"methodPUT": `methodPUT_hw3AJ`,
	"methodDELETE": `methodDELETE_q9NV0`,
	"methodPATCH": `methodPATCH_ks_Xz`,
	"title": `title_Yv_2c`,
	"buttonShowMore": `buttonShowMore_N8b2S`,
	"customSelector": `customSelector_JMk7L`,
	"selectorOption": `selectorOption_fkkob`,
	"optionsContainer": `optionsContainer_fehlA`,
	"type": `type_pPCNh`,
	"deleteOption": `deleteOption_lOPvy`,
	"infoDescription": `infoDescription_aDLlb`,
	"variableContainer": `variableContainer_wKffQ`,
	"searchVariable": `searchVariable_bsCeL`,
	"addVariableButton": `addVariableButton_qbOKw`,
	"searchContainerIcon": `searchContainerIcon_k8qsK`
};
export default ___CSS_LOADER_EXPORT___;
